<template>
    <div v-show="isActive" class="tab-pane">
        <slot/>
    </div>
</template>

<script>
export default {
    name: 'BTab',
    props: {
        title: {
            type: String,
            default: ''
        },
        active: {
            type: Boolean,
            default: false
        },
        htmlTitle: {
            type: Boolean,
            default: false
        },
        tabKey: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            isActive: this.active
        }
    },
    computed: {
        tabTitle () {
            return this.title
        },
        isHtmlTitle () {
            return this.htmlTitle
        },
        hrefKey () {
            return this.tabKey
        }
    },
    mounted () {
        if (this.$parent && this.$parent.registerTab) {
            this.$parent.registerTab(this)
        }
    },
    beforeUnmount () {
        if (this.$parent && this.$parent.unregisterTab) {
            this.$parent.unregisterTab(this)
        }
    }
}
</script>
